@if(crossParams.showCross) {
  <div class="fw-bold mb-1 text-truncate custom-line-height-cell custom-two-line-cell">
    <span class="fw-bold mb-1">
      @if(crossParams.isAptitudeProduct) {
        <i class="apt-logo-icon" data-test-selector="grid-aptitude-icon"></i>
      }
      @if(showDiscontinueBadge) {
        <span data-test-selector="grid-discontinued-badge" class="badge badge-pill bg-secondary">D/C</span>
      }

      @if (_routerLink) {
        <a [routerLink]="crossParams.productUrl" (click)="this.ngbActiveModal.close()" data-test-selector="three-line-with-title-as-link-anchor">{{crossParams.product}}</a>
      } @else {
        <a [href]="crossParams.productUrl" target="_blank" data-test-selector="three-line-with-title-as-link-anchor">{{crossParams.product}}</a>
      }
    </span>

    <span data-test-selector="three-line-with-title-as-link-description" class="text-muted fw-normal">
      {{crossParams.content}}
    </span>
  </div>
}